<template>
  <div class="text-sm">
    <p class="mt-6"><b>2025.02.11</b> - Mostly bugs & AI fixes :)</p>
    <ul class="ml-5 pb-4 list-outside list-disc">
      <li>Added an opt-out profanity filter for chat.</li>
      <li>Added a "Skip tutorial" button.</li>
      <li>Prayer Candle tooltips now state the candle's alignment.</li>
      <li>
        Balance: gave Blunt Arrow AP cost a nerf:
        <code>50 - L*2</code> --> <code>80 - L*2</code>
      </li>
      <li>
        AI
        <ul>
          <li>
            - Units will now target enemies with lowest EFFECTIVE health (HP * Armor
            Class), not just lowest HP.
          </li>
          <li>
            - Summon abilities no longer belong to the Support tree. Instead they're
            treated as self-buffs, which is now its own tree that is checked before the
            roles waterfall.
          </li>
          <li>- Units will not pass turn waiting for MP to cast a buff.</li>
          <li>
            - The Tank and DPS Close trees will now be completely ignored by "pure ranged"
            units (i.e. has Ranged DPS prioritized above both, and no melee abilities
            equipped).
          </li>
          <li>
            - Melee heroes will now only use Mortal Strike if it will kill the target.
          </li>
          <li>- Fixed a bug causing units with Leap to hop around randomly.</li>
          <li>- Interference units will no longer stun a feared target</li>
          <li>- Now no one anywhere will ever target a summoned unit for healing.</li>
        </ul>
      </li>
      <li>
        Bugs
        <ul>
          <li>- Fixed a bug with Mortal Strike AI rendering ghost damage.</li>
          <li>- Fixed AP cost refund for Mortal Strike.</li>
          <li>- Fixed a bug where weapons didn't proc off Sky Hammer.</li>
          <li>- Fixed a bug rendering Caverns loot after tabbing out and back.</li>
          <li>- Fixed a bug allowing Inn attacks when out of challenges.</li>
          <li>- Fixed the layout of item icons in the Battle Debrief modal.</li>
          <li>- Fixed the display of dye icons in inventory and the shop.</li>
          <li>- Fixed a bug dropping Caverns performance when the log gets full.</li>
          <li>- Fixed a bug making naked heroes hard to click.</li>
          <li>- Fixed the formatting of currency and HP/AP/MP displays.</li>
          <li>- Fixed message log spam when tabbing out and back in.</li>
        </ul>
      </li>
    </ul>
  </div>
</template>
